// extracted by mini-css-extract-plugin
module.exports = {"container":"_not-found_container__1WSlG"};